import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { Box } from '../../components/Box'
import { TransactionTableComponent } from './components/TransactionTableComponent'

export const Dashboard: React.FC = () => {
  return (
        <div className="content-wrapper">
            <section className="content">
                <div className="container-fluid">
                    <Row>
                        <Col md={12}>
                            <Box
                                loaded={true}
                                title={
                                    <div>
                                        <i className="fas fa-table mr-1"/>
                                        Transakcie
                                    </div>
                                }
                                isTable={true}
                            >
                                <div className="box-overflow" style={{ minHeight: '212px' }}>
                                    <TransactionTableComponent/>
                                </div>
                            </Box>
                        </Col>
                    </Row>
                </div>
            </section>
        </div>
  )
}

export default Dashboard
